import axios from "axios";
import { isInsideIframe, openExternalUrl } from "../openExternalUrl";

const API = String(process.env.REACT_APP_API_URL || "")
  .trim()
  .replace(/\/+$/, "");

/**
 * Abre Google OAuth desde el iframe del CRM (postMessage → pestaña nueva).
 */
function navigateToOAuthUrl(url) {
  const href = String(url || "").trim();
  if (!href) return false;

  if (isInsideIframe()) {
    try {
      window.parent.postMessage({ type: "UNIBOX_OPEN_LINK", url: href }, "*");
      return true;
    } catch {
      /* fall through */
    }
  }

  if (openExternalUrl(href)) return true;

  const popup = window.open(href, "_blank", "noopener,noreferrer");
  if (popup) return true;

  throw new Error(
    "No se pudo abrir Google OAuth. Permite popups o abre Matrix fuera del CRM."
  );
}

/**
 * Inicia OAuth Google sin prompts nativos del navegador.
 *
 * @param {{ email?: string, oauthClient?: 'default'|'stage'|'manterola'|null }} opts
 */
export async function startGoogleOAuth({
  email = "",
  oauthClient = null,
} = {}) {
  const hint = String(email || "").trim().toLowerCase();
  if (hint && !hint.includes("@")) {
    throw new Error("Indica un email completo (ej. miguel@manterola.com).");
  }

  const body = {
    ...(hint ? { loginHint: hint, email: hint } : {}),
    ...(oauthClient ? { oauthClient } : {}),
  };

  const res = await axios.post(`${API}/auth/google/start`, body);
  const url = res.data?.url;
  if (!url || typeof url !== "string") {
    throw new Error("El servidor no devolvió una URL OAuth válida.");
  }

  const usedClient = res.data?.oauthClient || "default";
  if (
    (oauthClient === "manterola" || hint.endsWith("@manterola.com")) &&
    usedClient !== "manterola"
  ) {
    throw new Error(
      "El servidor no tiene configurado GOOGLE_CLIENT_ID_MANTEROLA. " +
        "Añádelo al .env de prod y reinicia el backend."
    );
  }

  navigateToOAuthUrl(url);
  return { ok: true, oauthClient: usedClient };
}

export function accountsNeedingGoogleReauth(accounts) {
  return (accounts || []).filter((acc) => {
    const type = String(acc.account_type || "google").toLowerCase();
    if (type === "imap") return false;
    return (
      acc.auth_status === "reauth_required" ||
      acc.auth_status === "missing_tokens"
    );
  });
}
